
import { Component, Vue } from 'vue-property-decorator';
import RideitChangeRequestTable from './RideitChangeRequestTable.vue';
import RideitChangeRequestFilterForm, { RideitChangeRequestFilterFormData } from './RideitChangeRequestFilterForm.vue';
import RideitChangeRequestDialog from './RideitChangeRequestDialog.vue';
import RideitChangeRequest, { IRideitChangeRequest, RideitChangeRequestStatus } from '@/models/Rideit/RideitChangeRequest';
import { Organization } from '@/models/Organization';
import Passenger from '@/components/Passenger/models/Passenger';
import Utility from '@/components/Passenger/models/Utility';
import restService from '@/services/restService';
import { getErrorMessage } from '@/util/errorMessageHelper';
import vuetifyToast from 'vuetify-toast';

@Component({
  components: {
    RideitChangeRequestTable,
    RideitChangeRequestFilterForm,
    RideitChangeRequestDialog,
  }
})
export default class RideitChangeRequests extends Vue {
  loading = false;
  errorMessage = '';
  groups: string[] = [];
  dialogOpen = false;
  selectedChangeRequest: RideitChangeRequest | null = null;

  filters: RideitChangeRequestFilterFormData = {
    passengerSearch: '',
    utilities: [] as number[],
    status: '',
  };

  onFiltersChange(newFilters: RideitChangeRequestFilterFormData) {
    this.filters = newFilters;
  }

  onRowClick(changeRequest: RideitChangeRequest) {
    this.selectedChangeRequest = changeRequest;
    this.dialogOpen = true;
  }

  async onApprove(changeRequest: RideitChangeRequest) {
    const org = this.getOrganization();
    this.loading = true;
    try {
      const result = await restService.rideit.approveChangeRequest(org.id, changeRequest.id, changeRequest);
const index = this.changeRequests.findIndex(r => r.id === changeRequest.id);
      if (index > -1) this.changeRequests.splice(index, 1, new RideitChangeRequest(result));
      this.dialogOpen = false;
      vuetifyToast.success(this.$t('rideIt.changeRequests.approve.success'));
    } catch (error) {
      vuetifyToast.error(this.$t('rideIt.changeRequests.approve.error', { errorMessage: getErrorMessage(error) }));
    } finally {
      this.loading = false;
    }
  }

  async onReject(changeRequest: RideitChangeRequest) {
    const org = this.getOrganization();
    this.loading = true;
    try {
      await restService.rideit.rejectChangeRequest(org.id, changeRequest.id);
      const index = this.changeRequests.findIndex(r => r.id === changeRequest.id);
      if (index > -1) this.changeRequests[index].status = RideitChangeRequestStatus.Rejected;
      this.dialogOpen = false;
      vuetifyToast.success(this.$t('rideIt.changeRequests.reject.success'));
    } catch (error) {
      vuetifyToast.error(this.$t('rideIt.changeRequests.reject.error', { errorMessage: getErrorMessage(error) }));
    } finally {
      this.loading = false;
    }
  }


  get filteredChangeRequests() {
    
    return this.changeRequests.filter(r => {
      if (this.filters.passengerSearch && !r.passengerName.toLowerCase().includes(this.filters.passengerSearch.toLowerCase())) {
        return false;
      }
    //   const requestIds = r.request.split(',').map(s => parseInt(s.trim()));
    //   if (this.filters.utilities.length > 0 && !this.filters.utilities.some(u => requestIds.includes(u))) {
    //     return false;
    //   }
      if (this.filters.status && r.status.toLocaleLowerCase() !== this.filters.status.toLocaleLowerCase()) {
        return false;
      }
      return true;
    });
  }

  getOrganization() {
    const organizationId = this.$route.params.organizationId;
    return this.$store.state.organization.organizations.find((o: Organization) => o.id === organizationId);
  }


  get utilityOptions() {
    const utilityOptions = Passenger.utilities.map(u => new Utility(u.id, u.title));
    return utilityOptions;        
}

  changeRequests: RideitChangeRequest[] = [];

  async mounted() {
    const org = this.getOrganization();
    if (!org) return;
    this.loading = true;
    this.errorMessage = '';
    try {
      const data = await restService.rideit.getChangeRequests(org.id);
      this.changeRequests = data.map((r: IRideitChangeRequest) => new RideitChangeRequest(r));
    } catch (error) {
      this.errorMessage = getErrorMessage(error);
    } finally {
      this.loading = false;
    }
  }
}
